import { TreeDesignTokens } from '@primeuix/themes/aura/tree';

export const treeTokens: TreeDesignTokens = {
  root: {
    background: '{content.background}',
    color: '{content.color}',
    padding: '1rem',
    gap: '2px',
    indent: '1rem',
    transitionDuration: '{transition.duration}',
  },
  node: {
    padding: '0.25rem 0.5rem',
    borderRadius: '{content.border.radius}',
    hoverBackground: '{content.hover.background}',
    hoverColor: '{text.hover.color}',
    selectedBackground: '{highlight.background}',
    selectedColor: '{highlight.color}',
    color: '{text.color}',
    gap: '0.25rem',
    focusRing: {
      width: '{focus.ring.width}',
      offset: '-1px',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      shadow: '{focus.ring.shadow}',
    },
  },
  nodeIcon: {
    color: '{text.muted.color}',
    hoverColor: '{text.hover.muted.color}',
    selectedColor: '{highlight.color}',
  },
  nodeToggleButton: {
    borderRadius: '{tree.node.toggle.button.size} / 2',
    size: '1.75rem',
    hoverBackground: '{content.hover.background}',
    hoverColor: '{text.hover.muted.color}',
    selectedHoverBackground: '{content.background}',
    selectedHoverColor: '{primary.color}',
    color: '{text.muted.color}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
  },
  loadingIcon: {
    size: '2rem',
  },
  filter: {
    margin: '0.5rem',
  },
};
